var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tab',{attrs:{"title":"Notificações"}},[_c('lista-notificacao')],1),_c('b-tab',{attrs:{"title":"Grupos de Notificação"}},[_c('lista-grupo-notificacao',{attrs:{"active":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }